import { QueryClient } from "@tanstack/react-query";
import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import type { RouterClient } from "@orpc/server";
import type { appRouter } from "@/server/orpc/router";

/** Singleton QueryClient for the SPA. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      retry: false,
    },
  },
});

const orpcLink = new RPCLink({
  url: `${window.location.origin}/api/rpc`,
});

export const orpcClient: RouterClient<typeof appRouter> = createORPCClient(orpcLink);
export const orpc = createTanstackQueryUtils(orpcClient);
